 
// Add modal HTML here

/* prevents unit tests from blowing up */
const Dialog = window.ds && window.ds.Dialog ? window.ds.Dialog : class Noop{};
class Modal extends Dialog{
    constructor(content, opts){
        super(content, opts);
    }
}
export default function modal(content, options) {
    return new Modal(content, options);
}